/** Route names owned by runtime module routing (ADR-0002). Used by the fixed-routes codegen plugin. */
export const MODULE_ROUTE_NAMES = new Set([
  'my-cases-v2',
  'my-cases-v2-deeplink',
  'my-children',
  'my-child',
  'my-eservices',
  'my-associations',
  'my-educations',
]);
